module.exports = __webpack_public_path__ + "static/science-of-hitting-da49c010e924979d6b7de04fe4b4add0.jpg";